import { replace } from 'connected-react-router';
import { PasswordResetErrorResponse, resetPassword as apiResetPassword } from '~/Api/Authentication/Password';
import { invokeApi, resolve } from '~/ApiClient';
import config from '~/config';
import { handleError } from '~/ErrorHandler';
import { flashSuccessMessage } from '~/FlashMessage';
import isValidEmail from '~/utils/Email/isValidEmail';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';

interface Errors {
	emailError: string | null;
	passwordError: string | null;
}

export function resetPassword(email: string): ThunkAction<Promise<Errors>, any> {
	return async (dispatch) => {
		const errors: Errors = { emailError: null, passwordError: null };

		if (!isValidEmail(email)) {
			errors.emailError = 'Please check that you entered your email correctly';
			return errors;
		}

		try {
			await dispatch(unhandledResetPassword(email));
			dispatch(replace({ pathname: '/login' }));
			dispatch(
				flashSuccessMessage(
					`Email with information about how to setup new password has been sent to your email ${email}`
				)
			);
			return errors;
		} catch (error) {
			if (!(error instanceof PasswordResetErrorResponse)) {
				dispatch(handleError(error));
				return errors;
			}
			if (error.handleUnknownEmail()) {
				errors.emailError = 'Unknown email, please check your email and try it again';
			}
			if (error.handleAuthenticationExpiredAccount()) {
				errors.emailError = `Your user account has expired, please contact ${config.support.email}`;
			}
			if (error.handleAuthenticationAccountDeactivated()) {
				errors.passwordError = `Your user account has been deactivated, please contact ${config.support.email}`;
			}
			dispatch(handleError(error));
			return errors;
		}
	};
}

export function unhandledResetPassword(email: string): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(apiResetPassword, email));
		dispatch({ type: ActionTypes.request, request });
		await resolve(request, () => dispatch({ type: ActionTypes.receive, request }));
	};
}
